'use client';
import { useState } from "react";
import ModalVideo from "vadimages-react-modal-video";
import "vadimages-react-modal-video/css/modal-video.min.css";
import VadImage from "vadimages-nextjs-image-optimizer";

export type ModalVideoFromImageBlockProps = {
    channel?: "vimeo" | "youtube";
    title?: string;
    imgSrc: string;
    imgWidth: number;
    imgHeight: number;
    imgAlt: string;
    video: string;
    id: number;
    className?: string;
    ratio?: `${number}:${number}`;
}
export function ModalVideoFromImageBlock({ channel = "vimeo", className, ...props }: ModalVideoFromImageBlockProps)
{
    const [isOpen, setOpen] = useState(false);

    // No scroll reveal here on purpose. The framer-motion this replaced had `variants` commented
    // out, so its "hidden"/"visible" targets resolved to nothing and these thumbnails never
    // actually animated in production — the reveal that the CSS port briefly added was resurrecting
    // dead code, not preserving behaviour. They render immediately, as they always have.
    return (<>
        <div className={className}>
            <div className={`video-link video-corners w-fit mx-auto`} onClick={() => setOpen(true)}>
                <figure>
                    <VadImage src={props.imgSrc} width={props.imgWidth} height={props.imgHeight} alt={props.imgAlt} className="min-h-[179px]"/>
                </figure>
            </div>
        </div>
        <ModalVideo
            channel={channel}
            isOpen={isOpen}
            videoId={props.video}
            onClose={() => setOpen(false)}
            ratio={!!props.ratio ? props.ratio : "16:9"}
        />
    </>)
}
